var OpenForHash = {

    me: this,

    InitOpenForHash: function (hashName) {
        if (hashName !== '') {
            hashName = hashName.replace('#', '');
            var anchor = document.querySelector(`a[name='${hashName}']`);
            if (anchor !== null) {
                //console.log('Got anchor : %o', hashName);
                let next = anchor.nextElementSibling;
                //console.log('Next : %o', next);
                if (next !== null) {
                    if (next.classList.contains('accordion__item')) {
                        let accTitle = next.querySelector('.accordion__title');
                        if (accTitle !== null) {
                            accTitle.click();   // Click it as it does some resizeing behind the scenes
                        }
                    } else {
                        //console.log('next class missing : %o', next.classList);
                    }
                 }
            } else {
                console.log('Anchor not found : %o', hashName);
            }
        }
    }
}